import { Component, OnDestroy, inject } from '@angular/core';
import { ToastCloseEvent } from 'primeng/types/toast';
import { AnnouncementToastService } from 'src/app/services/announcement-toast.service';

@Component({
  selector: 'app-announcement-toast',
  templateUrl: './announcement-toast.component.html',
  styleUrls: ['./announcement-toast.component.scss'],
  standalone: false
})
export class AnnouncementToastComponent implements OnDestroy {
  private readonly announcementToastService = inject(AnnouncementToastService);

  dismissAnnouncement(event: ToastCloseEvent): void {
    this.announcementToastService.dismissAnnouncement(event.message.data?._id);
  }

  ngOnDestroy(): void {
    this.announcementToastService.stop();
  }
}
